import { Box, Skeleton } from "@mui/material";

export default function TimeReportsVisitSummarySkeleton() {
    return (
        <>
            <Box padding={2}>
                <Skeleton variant="text" width={120} height={16} />
                <Skeleton variant="text" width={40} height={24} />
            </Box>
            <Box padding={2}>
                <Skeleton variant="text" width={60} height={16} />
                <Skeleton variant="text" width={80} height={24} />
                <Skeleton variant="text" width={100} height={20} />
            </Box>
            <Box padding={2}>
                <Skeleton variant="text" width={60} height={16} />
                <Skeleton variant="text" width={80} height={24} />
                <Skeleton variant="text" width={100} height={20} />
            </Box>
            <Box padding={2}>
                <Skeleton variant="text" width={120} height={16} />
                <Skeleton variant="text" width={80} height={24} />
            </Box>
        </>
    );
}
